import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

interface SpinnerProps {
  loadingText?: string;
}

const Spinner: React.FC<SpinnerProps> = (props) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100vh', width: '100%' }}>
      <CircularProgress sx={{ mb: 20 }} />
    </Box>
  );
};

export default Spinner;
